import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { saveEmployeeDetails } from "../../store/service";
import { Notification } from "../common/Notification";

function EditEmployee(props: any) {
    const { register, errors, handleSubmit, watch, setError, clearErrors } = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = (employeeInfo: any) => {
        if (employeeInfo.FirstName.trim() && employeeInfo.LastName.trim()) {
            setIsLoading(true);
            saveEmployeeDetails({
                EmployeeList: [
                    {
                        ...employeeInfo,
                        Id: props.currentRecord.Id,
                        FirstName: employeeInfo.FirstName.trim(),
                        LastName: employeeInfo.LastName.trim(),
                        Action: "",
                    },
                ],
            })
                .then((res) => {
                    setIsLoading(false);
                    if (res.hasError) {
                        Notification({
                            type: "error",
                            title: "Error",
                            message: res.errors[0],
                            duration: 5,
                        });
                    } else {
                        Notification({
                            type: "success",
                            title: "Success",
                            message: "Employee Successfully Updated",
                            duration: 5,
                        });
                        props.handleContinue();
                        props.closeDialog();
                    }
                })
                .catch((err) => {
                    setIsLoading(false);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: err,
                        duration: 5,
                    });
                });
        } else {
            if (!employeeInfo.FirstName.trim()) {
                setError("FirstName", {
                    type: "required",
                    message: "",
                });
            }
            if (!employeeInfo.LastName.trim()) {
                setError("LastName", {
                    type: "required",
                    message: "",
                });
            }
        }
    };

    return (
        <>
            <div className="dialog-header">
                <div className="col-xs">
                    <h1 className="title-page" id="title-page">
                        Edit Employee
                    </h1>
                </div>
            </div>
            <div className={isLoading ? "loading dialog-body" : "dialog-body"}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <fieldset className="form-row inline">
                        <div className="row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <legend className="legend-label">First Name</legend>
                            </div>
                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <div className="row">
                                    <div className="col-xs-12 col-no-gutter">
                                        <div className={errors["FirstName"] ? "form-row row status-error" : "form-row row"}>
                                            <div className="form-row row">
                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                    <label htmlFor="label-first-name">First Name</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-no-gutter">
                                                    <input
                                                        type="text"
                                                        className="inputbox"
                                                        id="label-first-name"
                                                        name="FirstName"
                                                        ref={register({
                                                            pattern: /^[a-zA-Z-'\s.]+$/,
                                                            required: true,
                                                        })}
                                                        defaultValue={props.currentRecord && props.currentRecord.FirstName ? props.currentRecord.FirstName : ""}
                                                        onBlur={() => {
                                                            if (!watch("FirstName").trim().length) {
                                                                setError("FirstName", {
                                                                    type: "pattern",
                                                                    message: "",
                                                                });
                                                            }
                                                        }}
                                                    />
                                                    {errors.FirstName && errors.FirstName.type === "pattern" && (
                                                        <span className="form-error">
                                                            Please enter a first name that only uses letters, spaces, and the characters -'
                                                        </span>
                                                    )}
                                                    {errors.FirstName && errors.FirstName.type === "required" && (
                                                        <span className="form-error">First Name is required</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset className="form-row inline">
                        <div className="row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <legend className="legend-label">Last Name</legend>
                            </div>
                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <div className="row">
                                    <div className="col-xs-12 col-no-gutter">
                                        <div className={errors["LastName"] ? "form-row row status-error" : "form-row row"}>
                                            <div className="form-row row">
                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                    <label htmlFor="label-last-name">Last Name</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-no-gutter">
                                                    <input
                                                        type="text"
                                                        className="inputbox"
                                                        id="label-last-name"
                                                        name="LastName"
                                                        ref={register({
                                                            pattern: /^[a-zA-Z-'\s.]+$/,
                                                            required: true,
                                                        })}
                                                        defaultValue={props.currentRecord && props.currentRecord.LastName ? props.currentRecord.LastName : ""}
                                                        onBlur={() => {
                                                            if (!watch("LastName").trim().length) {
                                                                setError("LastName", {
                                                                    type: "pattern",
                                                                    message: "",
                                                                });
                                                            }
                                                        }}
                                                    />
                                                    {errors.LastName && errors.LastName.type === "pattern" && (
                                                        <span className="form-error">
                                                            Please enter a last name that only uses letters, spaces, and the characters -'
                                                        </span>
                                                    )}
                                                    {errors.LastName && errors.LastName.type === "required" && (
                                                        <span className="form-error">Last Name is required</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset className="form-row inline">
                        <div className="row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <legend className="legend-label">Email Address</legend>
                            </div>
                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <div className="row">
                                    <div className="col-xs-12 col-no-gutter">
                                        <div className={errors["Email"] ? "form-row row status-error" : "form-row row"}>
                                            <div className="form-row row">
                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                    <label htmlFor="label-email-address">Email Address</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-no-gutter">
                                                    <input
                                                        type="text"
                                                        className="inputbox"
                                                        id="label-email-address"
                                                        name="Email"
                                                        ref={register({
                                                            pattern: /^\w+([-+.']\w+)*[\-]?@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                                                            required: !(
                                                                props.currentRecord.Email ||
                                                                props.currentRecord.SMSContact ||
                                                                watch("Email") ||
                                                                watch("SMSContact")
                                                            ),
                                                        })}
                                                        defaultValue={props.currentRecord && props.currentRecord.Email ? props.currentRecord.Email : ""}
                                                        onChange={() => {
                                                            if (!(watch("Email") || watch("SMSContact"))) {
                                                                setError("Email", {
                                                                    type: "required",
                                                                });
                                                            } else {
                                                                clearErrors("Email");
                                                            }
                                                        }}
                                                    />
                                                    {errors.Email && errors.Email.type === "pattern" && (
                                                        <span className="form-error">
                                                            Please enter a valid email address including a "@" and "." For example: "janesmith123@gmail.com"
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset className="form-row inline">
                        <div className="row">
                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                <legend className="legend-label">Mobile Number</legend>
                            </div>
                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                <div className="row">
                                    <div className="col-xs-12 col-no-gutter">
                                        <div className={errors["SMSContact"] ? "form-row row status-error" : "form-row row"}>
                                            <div className="form-row row">
                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                    <label htmlFor="label-mobile-number">Mobile Number</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-no-gutter">
                                                    <input
                                                        type="text"
                                                        className="inputbox"
                                                        name="SMSContact"
                                                        ref={register({
                                                            pattern: /^[(]?\d{3}[)]?[-.\s]?\d{3}[-.\s]?\d{4}$/,
                                                        })}
                                                        defaultValue={props.currentRecord && props.currentRecord.SMSContact ? props.currentRecord.SMSContact : ""}
                                                        id="label-mobile-number"
                                                        onChange={() => {
                                                            if (!(watch("Email") || watch("SMSContact"))) {
                                                                setError("Email", {
                                                                    type: "required",
                                                                });
                                                            } else {
                                                                clearErrors("Email");
                                                            }
                                                        }}
                                                    />
                                                    {errors.SMSContact && errors.SMSContact.type === "pattern" && (
                                                        <span className="form-error">Please provide a Mobile number in a valid 10 number format</span>
                                                    )}
                                                    {errors.Email && !watch("Email") && !watch("SMSContact") && (
                                                        <span className="form-error">Either Email or Mobile number is missing or invalid.</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <div className="row between-xs">
                        <div className="col-xs-12 col-sm-12 col-no-gutter flex-grow-null justify-space-bt">
                            <button type="submit" className="btn-default btn-link btn-min-width" onClick={props.closeDialog}>
                                <span className="btn-text">Cancel</span>
                            </button>
                            <button
                                type="submit"
                                className="btn-default btn-primary btn-min-width"
                                onClick={() =>
                                    window.addToDataLayer({
                                        event: "Button Update Employee Click",
                                    })
                                }
                                disabled={Object.keys(errors).length !== 0}
                            >
                                <span className="btn-text">Save</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default EditEmployee;
